module.exports = __webpack_public_path__ + "img/newswiper_5.67cbdbca.png";